module.exports = __webpack_public_path__ + "static/media/sam-pumps.cf5174be.png";